import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoadingSpinner } from '../components';
import ProtectedRoute from './ProtectedRoute';

// Route-level code splitting: each page (and everything it only
// imports) ships in its own chunk instead of one bundle everyone
// downloads up front - AddMedia alone is 93 files (the whole admin
// ingestion wizard), which a visitor just watching something never
// needs to load at all.
const Home = lazy(() =>
  import('../pages/Home').then((module) => ({ default: module.Home })),
);
const TvMode = lazy(() =>
  import('../pages/TvMode').then((module) => ({
    default: module.TvMode,
  })),
);
const Catalog = lazy(() =>
  import('../pages/Catalog').then((module) => ({
    default: module.Catalog,
  })),
);
const Detail = lazy(() =>
  import('../pages/Detail').then((module) => ({ default: module.Detail })),
);
const TVShowSeasonDetail = lazy(() =>
  import('../pages/TVShowSeasonDetail').then((module) => ({
    default: module.TVShowSeasonDetail,
  })),
);
const TVShowEpisodeDetail = lazy(() =>
  import('../pages/TVShowEpisodeDetail').then((module) => ({
    default: module.TVShowEpisodeDetail,
  })),
);
const Login = lazy(() =>
  import('../pages/Login').then((module) => ({ default: module.Login })),
);
const AddMedia = lazy(() =>
  import('../pages/AddMedia').then((module) => ({
    default: module.AddMedia,
  })),
);
const Profile = lazy(() =>
  import('../pages/Profile').then((module) => ({
    default: module.Profile,
  })),
);

/**
 * The fallback shown while a route's chunk loads is shaped like a page
 * rather than being a bare spinner.
 *
 * Nothing holds the footer at the bottom by itself: the app is a
 * full-height column of header, page and footer, and it is the
 * container's flex-grow that takes up the slack. A fallback without one
 * leaves nothing to grow, so for as long as the chunk is loading the
 * footer sits halfway up the screen with empty space below it - on
 * every lazy page, this being the one place they all share.
 */
const RouteLoading = () => (
  <div className="container">
    <div className="list-no-item-single">
      <LoadingSpinner />
    </div>
  </div>
);

// Development only, and outside ProtectedRoute: it shows no real
// data, talks to nothing, and the point of it is to be reachable in
// one step. import.meta.env.DEV is replaced by a literal at build
// time, so the whole page is dropped from a production bundle rather
// than merely being unreachable in it.
// The guard is on the import and not only on the route: a top-level
// lazy() keeps its import() alive whatever the route table does, so
// the page shipped to production and was merely unreachable there.
// import.meta.env.DEV is replaced by a literal at build time, so in a
// production build this is the false branch of a constant ternary and
// the whole page goes with it.
const Preview = import.meta.env.DEV
  ? lazy(() =>
      import('../pages/Preview').then((module) => ({
        default: module.Preview,
      })),
    )
  : null;

export const SiteRoutes = () => {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Routes>
        {import.meta.env.DEV && Preview && (
          <Route path="/preview" element={<Preview />} />
        )}
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Home />} />
          {/* Before /:category, which would otherwise swallow it. */}
          <Route path="/tv-mode" element={<TvMode />} />
          <Route path="/:category" element={<Catalog />} />
          {/* <Route path="/:category/search/:keyword" element={<Catalog />} />
        <Route path="/:category/search/tag/:tag" element={<Catalog />} />
        <Route
          path="/:category/search/collection/:collection"
          element={<Catalog />}
        />
        <Route path="/:category/search/studio/:studio" element={<Catalog />} /> */}
          <Route path="/:category/:id" element={<Detail />} />
          <Route
            path="/tv-shows/season/:id"
            element={<TVShowSeasonDetail />}
          />
          <Route
            // path="/tv-shows/:id/season/:seasonID/episode/:episodeID"
            path="/tv-shows/season/episode/:id"
            element={<TVShowEpisodeDetail />}
          />
          <Route path="/add-media" element={<AddMedia />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
